// extracted by mini-css-extract-plugin
export default {"header":"Categories_header__ZoeCJ"};